// local
// actions
import * as SimpleModal from '../simpleModal';
import { pending, rejected } from '../async';
import dispatchError from '../error';
import { openModal as openDisableError } from './disableErrorModal';
import { showSnackbar } from '../snackbar';
import { updateRow } from './data';
// api
import Patient from 'app/api/patient';

const ACTION_KEY = 'MODAL_DISABLE_PATIENT';

export const openModal = (data, onSuccessCallback) => SimpleModal.openModal(ACTION_KEY, data, onSuccessCallback);

export const closeModal = () => SimpleModal.closeModal(ACTION_KEY);

export const deinit = (id, data, onSuccessCallback) => dispatch => {
    dispatch(pending(ACTION_KEY));
    Patient.deinit(id, data)
        .then(payload => {
            dispatch(updateRow(payload));
            dispatch(showSnackbar({ title: `O paciente ${payload.name} foi desativado.`, action: true }));
            if (onSuccessCallback) {
                onSuccessCallback();
            }
            dispatch(closeModal());
        })
        .catch(err =>
            dispatchError(dispatch, err, () => {
                let error = null;
                if ((error = err.getValue('patient_deinit__scheduled_replacements')) !== null) {
                    dispatch(openDisableError(error.data));
                    dispatch(closeModal());
                } else {
                    dispatch(rejected(ACTION_KEY, err, false));
                }
            }),
        );
};
